function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M182.569 39.6576C167.744 41.1258 140.566 43.4558 132.128 11.9653C125.371 -13.254 105.822 -16.1741 88.1442 -1.0674C69.8552 14.5614 66.3702 50.7811 40.0613 52.3709C13.7525 53.9608 -4.78593 60.3376 2.59453 87.8818M116.839 76.5636C93.4071 40.9398 33.2713 69.3505 34.4564 98.638",
  stroke: "url(#paint0_linear_9337_163576)",
  strokeOpacity: 0.6
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_9337_163576",
  x1: 97.4053,
  y1: 81.7709,
  x2: 74.989,
  y2: -1.88791,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})));

function SvgBannerBlueRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 72,
    viewBox: "0 0 172 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBlueRight);
export default __webpack_public_path__ + "static/media/BannerBlueRight.3ec1109e7d34217fc56b27c970f745aa.svg";
export { ForwardRef as ReactComponent };